import { connect } from "react-redux";
import { RootState } from "../../../../store/types";
import RatesAndRosterHeader from "./RatesAndRosterHeader";

const mapStateToProps = (state: RootState) => ({
    planId: state.shiftPlan.planId,
    rosterData: state.rosterAndRates.ratesAndRoster?.rosterData,
    availableLabor: state.rosterAndRates.ratesAndRoster?.rosterData?.availableLabor
});

export default connect(mapStateToProps)(RatesAndRosterHeader);
